module.exports = __webpack_public_path__ + "static/media/cloze-rabbit-hole.ed833bc8.svg";